<template>
	<div>
		<SOFilterTitle :title="'Pilihan Filter'" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" :id="id">
			<SOInputRadio
				:radios="jenisOwner"
        :v2="true"
				:selected-radio="selectedItem"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputRadio from "@/so-components/global/input/SOInputRadio";

export default {
	name: "SOFilterOwner",
	components: {
		SOFilterTitle,
		SOInputRadio,
	},
	props: {
		id: String,
		jenisOwner: Array,
	},
  data() {
    return {
      diterapkan: false
    }
  },
  mounted() {
    this.diterapkan = this.getFilterItem.afiliasiOwner.length > 0;
  },
	computed: {
		...mapGetters("filterGlobalModule", {
			getFilterItem: "getFilterItem"
		}),
    selectedItem() {
      return this.getFilterItem.afiliasiOwner;
    }
	},
	methods: {
		selected(val) {
      let temp = this.getFilterItem;
      temp.afiliasiOwner = val.value;
      this.$store.commit("filterGlobalModule/setFilterItem", temp);
      this.diterapkan = this.getFilterItem.afiliasiOwner.length > 0;
    },
	}
}
</script>